<svelte:head>
  <title>Changelog - LastMinute</title>
</svelte:head>

<div class="px-6 pt-10 lg:px-8 lg:pt-40">
  <div class="mx-auto max-w-7xl px-6 lg:px-8">
    <div class="sm:align-center sm:flex sm:flex-col">
      <h1 class="text-5xl font-medium text-gray-100 sm:text-center">Changelog</h1>
      <p class="mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-400">
        New updates and improvements to LastMinute. We are constantly adding and refining features,
        based on customer feedback. Follow along!
      </p>
    </div>
    <div class="mx-auto max-w-2xl">
      <div class="mt-6 space-y-8 pt-10 sm:mt-4 sm:pt-8">
        <article class="flex max-w-xl flex-col items-start justify-between">
          <div class="flex items-center gap-x-4 text-xs">
            <time datetime="2024-06-14" class="text-gray-400">Jun 14, 2024</time>
          </div>
          <div class="group relative">
            <h3 class="mt-3 text-lg font-semibold leading-6 text-gray-200">
              <span class="absolute inset-0"></span>
              Shift Swapping
            </h3>
            <p class="mt-5 line-clamp-3 text-sm leading-6 text-gray-400">
              Users can now swap shifts with other employees, without needing to involve a manager.
              Managers can approve or deny shift swaps, and the schedule is automatically updated.
              User credentials are automatically verified, and the system ensures that the swap is
              fair.
            </p>
          </div>
        </article>
        <article class="flex max-w-xl flex-col items-start justify-between">
          <div class="flex items-center gap-x-4 text-xs">
            <time datetime="2024-06-01" class="text-gray-400">Jun 01, 2024</time>
          </div>
          <div class="group relative">
            <h3 class="mt-3 text-lg font-semibold leading-6 text-gray-200">
              <span class="absolute inset-0"></span>
              This changelog was released
            </h3>
            <p class="mt-5 line-clamp-3 text-sm leading-6 text-gray-400">
              Our changelog is now live. How meta is that! Stay tuned as we continue to update you
              on all the exciting enhancements and fixes — because who doesn't love a good
              changelog?
            </p>
          </div>
        </article>
      </div>
    </div>
  </div>
</div>
